// React
import { useEffect, useRef } from 'react';

// Animation
import { animate, easeInOut, inView } from 'framer-motion';

// Utils
import cn from '@/utils/cn';

// Styles
import styles from '../Animations.module.css';

const config = {
  type: 'spring' as const,
  duration: 0.6,
  ease: easeInOut,
};

interface RevealFadeInDownProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  delay?: number;
  offsetBeforeDisplay?: number;
}

function RevealFadeInDown({
  id,
  children,
  className = '',
  delay = 0,
  offsetBeforeDisplay = 0.5,
}: RevealFadeInDownProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      inView(
        ref.current,
        (element) => {
          animate(
            element,
            {
              opacity: 1,
              y: [-50, 0],
            },
            {
              ...config,
              bounce: 0,
              delay: delay + 0.3,
            },
          );
        },
        {
          amount: offsetBeforeDisplay,
        },
      );
    }
  }, []);

  return (
    <div id={id} className={cn([styles['fadein-down'], className])} ref={ref}>
      {children}
    </div>
  );
}

export default RevealFadeInDown;
